import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { DEPLOY_ACTIONS, STATE_CLASSES } from './constants';
export function getPath() {
  var _window, _window$location;
  return (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname.replace(/:\d*/, '').replace('//', '/'); // this is to fix homepage path
}

export var PACIFIC_TIMEZONE = 'America/Los_Angeles';
export var FORMATER = new Intl.DateTimeFormat("en-US", {
  timeZone: PACIFIC_TIMEZONE,
  timeZoneName: "shortGeneric",
  hour: "numeric",
  minute: "numeric",
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour12: false
});
export function parseDateTime(dateTime) {
  var date = new Date(dateTime);
  var dateTimeResult = FORMATER.format(date);
  return dateTimeResult;
}
export function changeToPacificTimezone(date) {
  // suppose the date is 12:00 UTC
  var invdate = new Date(date.toLocaleString('en-US', {
    timeZone: PACIFIC_TIMEZONE
  }));

  // then invdate will be 07:00 in Toronto
  // and the diff is 5 hours
  var diff = date.getTime() - invdate.getTime();

  // so 12:00 in Toronto is 17:00 UTC
  return new Date(date.getTime() - diff); // needs to substract
}

export function deployAction(_x) {
  return _deployAction.apply(this, arguments);
}
function _deployAction() {
  _deployAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var action, getSiteId, schedule, actions, getUserEmail, onSuccess, onFail, dispatchStateClasses, setMessage, setError, axios, data, _window2, _window2$location, response, _error$response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            action = _ref.action, getSiteId = _ref.getSiteId, schedule = _ref.schedule, actions = _ref.actions, getUserEmail = _ref.getUserEmail, onSuccess = _ref.onSuccess, onFail = _ref.onFail;
            dispatchStateClasses = actions.dispatchStateClasses, setMessage = actions.setMessage, setError = actions.setError;
            dispatchStateClasses({
              type: action,
              payload: STATE_CLASSES.LOADING
            });
            _context.next = 5;
            return import('axios');
          case 5:
            axios = _context.sent["default"];
            data = {
              siteId: getSiteId(),
              userEmail: getUserEmail(),
              process: action,
              platform: 'INSTANT_PREVIEW',
              triggeredAt: schedule
            };
            if (action === DEPLOY_ACTIONS.REVALIDATE_PATH) {
              data.path = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname.replace(/:\d*/, '').replace('//', '/'); // this is to fix homepage path
            }
            _context.prev = 8;
            _context.next = 11;
            return axios({
              url: "".concat(process.env.NEXT_PUBLIC_ORCHESTRATOR_API_URL, "/orchestrator"),
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_ORCHESTRATOR_API_KEY
              },
              data: data
            });
          case 11:
            response = _context.sent;
            setMessage(response.data.message);
            dispatchStateClasses({
              type: action,
              payload: STATE_CLASSES.DONE
            });
            onSuccess && onSuccess({
              action: action,
              payload: data,
              data: response.data
            });
            return _context.abrupt("return", response);
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](8);
            console.error("Error while applying ".concat(action, " action"), _context.t0);
            setError(true);
            setMessage(((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data.message) || _context.t0.message);
            dispatchStateClasses({
              type: action,
              payload: STATE_CLASSES.ERROR
            });
            onFail && onFail({
              action: action
            });
            return _context.abrupt("return", _context.t0);
          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 18]]);
  }));
  return _deployAction.apply(this, arguments);
}
export function deployActionV2(_x2) {
  return _deployActionV.apply(this, arguments);
}
function _deployActionV() {
  _deployActionV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var action, getSiteId, schedule, actions, getUserEmail, onSuccess, onFail, environment, dispatchStateClasses, setMessage, setError, axios, data, _window3, _window3$location, response, _error$response2;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            action = _ref2.action, getSiteId = _ref2.getSiteId, schedule = _ref2.schedule, actions = _ref2.actions, getUserEmail = _ref2.getUserEmail, onSuccess = _ref2.onSuccess, onFail = _ref2.onFail, environment = _ref2.environment;
            dispatchStateClasses = actions.dispatchStateClasses, setMessage = actions.setMessage, setError = actions.setError;
            dispatchStateClasses({
              type: action,
              payload: STATE_CLASSES.LOADING
            });
            _context2.next = 5;
            return import('axios');
          case 5:
            axios = _context2.sent["default"];
            data = {
              siteId: getSiteId(),
              userEmail: getUserEmail(),
              process: action,
              platform: 'INSTANT_PREVIEW',
              triggeredAt: schedule,
              environment: environment
            };
            if (action === DEPLOY_ACTIONS.REVALIDATE_PATH) {
              data.path = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.pathname.replace(/:\d*/, '').replace('//', '/'); // this is to fix homepage path
            }
            _context2.prev = 8;
            _context2.next = 11;
            return axios({
              url: "".concat(process.env.NEXT_PUBLIC_ORCHESTRATOR_API_URL, "/orchestratorV2"),
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_ORCHESTRATOR_API_KEY
              },
              data: data
            });
          case 11:
            response = _context2.sent;
            setMessage(response.data.message);
            dispatchStateClasses({
              type: action,
              payload: STATE_CLASSES.DONE
            });
            onSuccess && onSuccess({
              action: action,
              payload: data,
              data: response.data
            });
            return _context2.abrupt("return", response);
          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](8);
            console.error("Error while applying ".concat(action, " action"), _context2.t0);
            setError(true);
            setMessage(((_error$response2 = _context2.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.message) || _context2.t0.message);
            dispatchStateClasses({
              type: action,
              payload: STATE_CLASSES.ERROR
            });
            onFail && onFail({
              action: action
            });
            return _context2.abrupt("return", _context2.t0);
          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 18]]);
  }));
  return _deployActionV.apply(this, arguments);
}
export function cancelSchedule(_x3) {
  return _cancelSchedule.apply(this, arguments);
}
function _cancelSchedule() {
  _cancelSchedule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var id, setScheduled, onSuccess, onFail, axios, response, _error$response3, _error$response3$data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            id = _ref3.id, setScheduled = _ref3.setScheduled, onSuccess = _ref3.onSuccess, onFail = _ref3.onFail;
            _context3.next = 3;
            return import('axios');
          case 3:
            axios = _context3.sent["default"];
            _context3.prev = 4;
            _context3.next = 7;
            return axios({
              url: "".concat(process.env.NEXT_PUBLIC_ORCHESTRATOR_API_URL, "/cancelScheduledProcess?id=").concat(id),
              method: 'put',
              headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_ORCHESTRATOR_API_KEY
              }
            });
          case 7:
            response = _context3.sent;
            setScheduled(function (prev) {
              return prev.filter(function (item) {
                return item.Id !== id;
              });
            });
            onSuccess && onSuccess();
            _context3.next = 16;
            break;
          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](4);
            console.error("Error while cancelling scheduled process", _context3.t0);
            onFail && onFail({
              message: (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_error$response3 = _context3.t0.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.message) || _context3.t0.message
            });
          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 12]]);
  }));
  return _cancelSchedule.apply(this, arguments);
}